<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="posting ? posting.company_name : ''" :isFilter="false" />
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="posting ? posting.company_name : ''" :isFilter="false" />
            </template>
            <div v-if="posting">
                <b-button variant="outline-secondary" class="mb-3" @click="$router.push('/coop/student')">
                    <i class="ri-arrow-left-line"></i> {{ $t('back') }}
                </b-button>

                <h6 class="mb-3">{{ posting.position }}</h6>

                <fieldset class="border p-3 mb-3 rounded">
                    <legend class="w-auto px-2 font-weight-bold h6">{{ $t('coop_posting_info') }}</legend>
                    <div>{{ $t('coop_location') }}: {{ posting.location }}</div>
                    <div>{{ $t('coop_quota') }}: {{ posting.quota }}</div>
                    <div>{{ $t('coop_last_application_date') }}: {{ posting.last_application_date }}</div>
                    <div>{{ $t('coop_fee') }}: {{ posting.fee }}</div>
                </fieldset>

                <fieldset class="border p-3 mb-3 rounded">
                    <legend class="w-auto px-2 font-weight-bold h6">{{ $t('coop_company_intro') }}</legend>
                    <p class="mb-0">{{ posting.company_description }}</p>
                </fieldset>

                <fieldset class="border p-3 mb-3 rounded">
                    <legend class="w-auto px-2 font-weight-bold h6">{{ $t('coop_required_qualifications') }}</legend>
                    <ul class="mb-0">
                        <li v-for="(qualification, index) in posting.qualifications" :key="index">{{ qualification }}</li>
                    </ul>
                </fieldset>

                <fieldset class="border p-3 mb-3 rounded">
                    <legend class="w-auto px-2 font-weight-bold h6">{{ $t('coop_provided_benefits') }}</legend>
                    <div v-for="(benefit, index) in posting.benefits" :key="index">{{ benefit }}</div>
                </fieldset>

                <fieldset class="border p-3 mb-3 rounded">
                    <legend class="w-auto px-2 d-flex align-items-center">
                        <span class="font-weight-bold h6 mb-0">{{ $t('coop_application') }}</span>
                        <b-badge class="ml-2" :variant="isApplicationSent ? 'success' : 'secondary'">
                            {{ $t('application_status') }}: {{ applicationStatusLabel }}
                        </b-badge>
                    </legend>
                    <b-form-group :label="$t('coop_available_working_days')">
                        <b-form-select v-model="applicationForm.available_days"
                                       :options="weekDayOptions"
                                       :disabled="isApplicationSent"/>
                    </b-form-group>
                    <b-form-group>
                        <b-form-checkbox v-model="applicationForm.kvkk_approved" :disabled="isApplicationSent">
                            {{ $t('coop_kvkk_approval_text') }}
                        </b-form-checkbox>
                        <b-form-checkbox v-model="applicationForm.terms_approved" :disabled="isApplicationSent">
                            {{ $t('coop_terms_approval_text') }}
                        </b-form-checkbox>
                    </b-form-group>
                    <div class="d-flex align-items-center">
                        <b-dropdown :text="selectedCvName || $t('coop_select_cv')" variant="outline-secondary" class="mr-2" :disabled="isApplicationSent">
                            <b-dropdown-item v-for="cv in myCvs" :key="cv.id" @click="selectedCvId = cv.id">
                                {{ cv.name }}
                            </b-dropdown-item>
                        </b-dropdown>
                        <b-button variant="primary" :disabled="isApplicationSent" @click="submitApplication">
                            {{ $t('coop_submit_application') }}
                        </b-button>
                    </div>
                </fieldset>
            </div>
        </app-layout>
    </div>
</template>
<script>
    //Template
    import AppLayout from '@/layouts/AppLayout';
    import Header from '@/layouts/AppLayout/Header'
    import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'

    //Service
    import CoopAnnouncementService from '@/services/CoopAnnouncementService';
    import CoopCvService from '@/services/CoopCvService';

    export default {
        components: {
            AppLayout,
            Header,
            HeaderMobile
        },
        metaInfo() {
            return {
                title: this.posting ? this.posting.company_name : this.$t('coop_posting_info')
            }
        },
        data() {
            return {
                posting: null,
                myCvs: [],
                selectedCvId: null,
                applicationForm: {
                    available_days: null,
                    kvkk_approved: false,
                    terms_approved: false
                },
                weekDayOptions: [
                    { value: 'monday', text: this.$t('monday') },
                    { value: 'tuesday', text: this.$t('tuesday') },
                    { value: 'wednesday', text: this.$t('wednesday') },
                    { value: 'thursday', text: this.$t('thursday') },
                    { value: 'friday', text: this.$t('friday') }
                ]
            };
        },
        computed: {
            isApplicationSent() {
                return this.posting && this.posting.application_status === 'sent';
            },
            applicationStatusLabel() {
                return this.isApplicationSent ? this.$t('sent') : this.$t('coop_application_draft');
            },
            selectedCvName() {
                const cv = this.myCvs.find((item) => item.id === this.selectedCvId);
                return cv ? cv.name : null;
            }
        },
        methods: {
            getPosting() {
                CoopAnnouncementService.show(this.$route.params.id).then((response) => {
                    this.posting = response.data.data;
                });
            },
            submitApplication() {
                if (!this.selectedCvId) {
                    this.$toast.error(this.$t('coop_please_select_cv'));
                    return;
                }
                if (!this.applicationForm.kvkk_approved || !this.applicationForm.terms_approved) {
                    this.$toast.error(this.$t('coop_please_approve_terms'));
                    return;
                }

                CoopAnnouncementService.apply(this.posting.id, {
                    cv_id: this.selectedCvId,
                    available_days: this.applicationForm.available_days
                }).then(() => {
                    this.$toast.success(this.$t('coop_application_sent_success'));
                    this.getPosting();
                });
            }
        },
        created() {
            this.getPosting();
            CoopCvService.getAll().then((response) => {
                this.myCvs = response.data.data;
            });
        }
    }
</script>
